module.exports = __webpack_public_path__ + "img/de973de.svg";